import { render, staticRenderFns } from "./LoginFormModal.vue?vue&type=template&id=fb784ec2&scoped=true&"
import script from "./LoginFormModal.vue?vue&type=script&lang=js&"
export * from "./LoginFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb784ec2",
  null
  
)

export default component.exports